import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { defineNextPage } from '@/common/next';
import FeatureContext from '@/pages/--roboneo/landing_page/index';
import SeoFooter from '@/components/SeoFooter';
import SeoCopyRight from '@/components/SeoCopyRight';
import styles from './index.module.scss';

const V0SeedanceCom = dynamic(() => import('@/pages/--roboneo/landing_page/components/seedance_page/index'));

/**
 * 检测 User-Agent 是否来自美图系 App 内嵌 WebView（与 SubApp 热区等逻辑一致：美图 App、开拍等）。
 */
function isMeituFamilyAppWebViewUserAgent(userAgent?: string): boolean {
  if (!userAgent) return false;
  return /com\.meitu|com\.starii\.xdesign/i.test(userAgent);
}

/**
 * 解析 URL 是否带 `in_app=true`（端上显式标记内嵌）。
 */
async function getSeedancePageInitialProps(context: { asPath?: string; }) {
  const asPath = context.asPath || '';
  const search = asPath.includes('?') ? asPath.split('?')[1] ?? '' : '';
  const searchParams = new URLSearchParams(search);
  const inApp = searchParams.get('in_app') === 'true';
  return { inApp };
}

/**
 * 独立 Seedance 落地页：不依赖 Essio CMS visitor-api。
 * 与 [...path].page.tsx 中 v0Seedance 分支一致，避免本地/未发布 CMS 时出现 NotFound。
 */
export default defineNextPage<{ inApp: boolean; userAgent?: string; }>({
  pageConfig: {
    projectId: '/--roboneo',
    layoutId: '',
    renderHead() {
      return (
        <Head>
          <title>RoboNeo</title>
        </Head>
      );
    },
  },
  getInitialProps: getSeedancePageInitialProps,
  component: ({ inApp, userAgent }) => {
    const ua = userAgent ?? (typeof window !== 'undefined' ? window.navigator.userAgent : undefined);
    const hideLandingChrome = inApp || isMeituFamilyAppWebViewUserAgent(ua);
    return (
      <>
        <main className={styles.main}>
          <FeatureContext
            v0Thumail
            hideHeader={hideLandingChrome}
            landingHeaderShowUserCardSystemSetting={!hideLandingChrome}
          >
            <V0SeedanceCom />
          </FeatureContext>
        </main>
        <footer className={styles.footerWrap}>
          <SeoFooter />
          <SeoCopyRight />
        </footer>
      </>
    );
  },
});
